import { Component, Input } from '@angular/core';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { SidebarDrawerComponent } from '../sidebar-drawer/sidebar-drawer.component';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {

  @Input() public toggle = false;

  constructor(private offcanvasService: NgbOffcanvas) {
  }

  ngOnInit() {
    this.offcanvasService.activeInstance.subscribe((data)=>{
      if(!data){
        this.toggle = false;
      }else{
        this.toggle = true;
      }
    })
  }

  toggleSideBar() {

    if (!this.toggle) {

      this.offcanvasService.open(SidebarDrawerComponent, { position: 'end' });

    } else {
      this.offcanvasService.dismiss();

    }

  }
}
